<!-- Center canvas: read-only summary, matches Main Banner's badge+card pattern -->
<div class="cr-cd-card" *ngIf="isPreview">
  <span class="cr-cd-badge">Counter</span>

  <div
    class="cr-cd-dropzone"
    [id]="block.blockId"
    [appInlineMedia]="block.variables?.['CountdownImage']"
    [inlineMediaBlockId]="block.blockId"
    (inlineMediaChange)="onChange($event, 'CountdownImage')"
  >
    <a *ngIf="block.variables?.['CountdownImage']; else emptyPreview" [href]="previewHref" target="_blank" rel="noopener">
      <img [src]="block.variables?.['CountdownImage']" [alt]="block.variables?.['CountdownAlt'] || ''" />
    </a>

    <ng-template #emptyPreview>
      <div class="cr-inline-media-icon">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-inline-media-title">Upload image</div>
      <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
    </ng-template>
  </div>
</div>

<!-- Right panel: real edit form -->
<div class="cr-cd-edit" *ngIf="!isPreview">
  <div class="cr-cd-field-row">
    <span class="cr-cd-field-label">Countdown Image</span>
    <span
      class="cr-cd-toggle"
      [class.cr-cd-toggle-on]="imageAsUpload"
      role="button"
      tabindex="0"
      [title]="imageAsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
      (click)="toggleImageMode()"
      (keydown.enter)="toggleImageMode()"
      (keydown.space)="toggleImageMode()"
    ></span>
  </div>
  <div class="cr-cd-image-field">
    <app-block-text
      [maxLength]="500"
      type="link"
      [blockData]="block.variables?.['CountdownImage'] ?? ''"
      (handleOnChange)="onChange($event, 'CountdownImage')"
      [placeholder]="countdownImagePlaceholder"
      variable="CountdownImage"
      [isImage]="imageAsUpload"
      [isPlainText]="true"
      [blockId]="block.blockId"
    ></app-block-text>
    <div class="cr-cd-empty-overlay" *ngIf="imageAsUpload && !block.variables?.['CountdownImage']">
      <div class="cr-cd-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-cd-title">Upload image</div>
      <div class="cr-cd-subtitle">PNG up to 2 mb</div>
    </div>
  </div>

  <div class="cr-cd-link-field">
    <app-field-editor-v2
      [maxLength]="500"
      type="action-link"
      [blockData]="block.variables?.['CountdownLink'] ?? ''"
      (handleOnChange)="onChange($event, 'CountdownLink')"
      [placeholder]="countdownLinkPlaceholder"
      variable="CountdownLink"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'CountdownLinkSegmentRegex')"
      [selectedSegment]="block.variables?.['CountdownLinkSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <app-field-editor-v2
    type="alt"
    [blockData]="block.variables?.['CountdownAlt'] ?? ''"
    (handleOnChange)="onChange($event, 'CountdownAlt')"
    [placeholder]="countdownAltPlaceholder"
    [maxLength]="500"
    variable="CountdownAlt"
    [disabled]="disabled"
  ></app-field-editor-v2>
</div>
